import { gettext } from '@eb/i18n-ebspa';

/* GDPR Modal */
export const GDPR_MODAL_HEADER = gettext('Get alerts for new events');
export const GDPR_MODAL_DESCRIPTION = gettext(
    'By clicking okay, you are agreeing to receive marketing emails and notifications about creators you follow so that you don’t miss out.',
);
export const GDPR_ACCEPT_COPY = gettext('Okay');
export const GDPR_REJECT_COPY = gettext('No Thanks');
export const SAVE_ORGANIZER_FOLLOW_PREFERENCE_ERROR = gettext(
    'There was an issue saving your preference.',
);
export const GDPR_COLLECTION_MODAL_HEADER = gettext(
    'Get updates on this collection',
);
export const GDPR_COLLECTION_MODAL_DESCRIPTION = gettext(
    'By clicking okay, you are agreeing to receive marketing emails and notifications about collections you follow so that you don’t miss out.',
);
